import {DealTagsDao} from '../../dao';
import {TagModel} from '../../models';
import {ErrorModel} from '../../models';
import {SERVICE_CODE} from './_serviceCode';
const FUNCTION_CODE = 'UPDATE_CUSTOMER_CATEGORY_BY_ID';

export async function updateDealTag(
    userData: Record<string, string>,
    dealTagId: number,
    update: Record<string, any>
) {
    try {
        const result = await DealTagsDao.updateDealTag(userData.userToken, dealTagId, update);

        const resultParsed = TagModel.parseTag(result);

        return resultParsed;
    }
    catch (error) {
        throw ErrorModel.newError({
            code: `${SERVICE_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue.',
            error: error
        });
    }
}
